import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useProfileContext } from "../contexts/ProfileContexts";

const Downloads = () => {
  const { user } = useProfileContext();

  return (
    <Container>
      <h1 className="center">Downloads</h1>
      <div className="align-left">
        {user && user.planname === "free" && (
          <p>
            You must upgrade to download the latest version of Stubminer.{" "}
            <Link to="/account">Upgrade here</Link>.
          </p>
        )}
        {user && user.planname !== "free" && (
          <ul>
            <li>
              <a href="/downloads/stubminer.26.0.8.bak">Stubminer 26.0.8</a>
              <ul>
                <li>August 10, 2026</li>
                <li>Make more references less brittle</li>
              </ul>
            </li>
            <li>
              <a href="/downloads/stubminer26.0.7.bak">Stubminer 26.0.7</a>
              <ul>
                <li>June 23, 2026</li>
                <li>Make more references less brittle</li>
              </ul>
            </li>
            <li>
              <a href="/downloads/stubminer26.0.6.bak">Stubminer 26.0.6</a>
              <ul>
                <li>June 15, 2026</li>
                <li>Make references less brittle</li>
              </ul>
            </li>
            <li>
              <a href="/downloads/stubminer26.0.5.bak">Stubminer 26.0.5</a>
              <ul>
                <li>June 11, 2026</li>
                <li>Accomodate updates to the companion app</li>
                <li>Ensure you have version 6.5.7 of the companion app</li>
              </ul>
            </li>
            <li>
              <a href="/downloads/stubminer26.0.4.bak">Stubminer 26.0.4</a>
              <ul>
                <li>June 11, 2026</li>
                <li>Accomodate updates to the companion app</li>
                <li>Ensure you have version 6.5.4 of the companion app</li>
              </ul>
            </li>
            <li>
              <a href="/downloads/stubminer26.0.3.bak">Stubminer 26.0.3</a>
              <ul>
                <li>March 26, 2026</li>
                <li>Accomodate updates to the companion app</li>
                <li>Ensure you have version 6.2.6 of the companion app</li>
                <li>
                  Known issue: cannot mine with equipment. This will be fixed
                  soon.
                </li>
              </ul>
            </li>
            <li>
              <a href="/downloads/stubminer26.0.2.bak">Stubminer 26.0.2</a>
              <ul>
                <li>March 13, 2026</li>
                <li>Updates for 2026</li>
                <li>This works with version 6.2.2 of the companion app</li>
              </ul>
            </li>
          </ul>
        )}
      </div>
    </Container>
  );
};

export default Downloads;
